'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var PasswordInput = require('@circlefin/components/lib/PasswordInput');
var Form_Context = require('../Form.Context/Form.Context.js');
var Form_OptionsContext = require('../Form.OptionsContext/Form.OptionsContext.js');

/**
 * Create Form PasswordInput.
 */ function createFormPasswordInput() {
    const FormPasswordInput = ({ name, hideError, onChange, ...props })=>{
        const { getError } = react.useContext(Form_Context.FormContext);
        const [, { getLabelSuffix }] = react.useContext(Form_OptionsContext.FormOptionsContext);
        const { field, fieldState } = reactHookForm.useController({
            name
        });
        const { isSubmitting } = reactHookForm.useFormState();
        const disabled = react.useMemo(()=>isSubmitting || props.disabled, [
            isSubmitting,
            props.disabled
        ]);
        const message = react.useMemo(()=>{
            if (!hideError) {
                const error = getError?.(fieldState.error);
                if (error) {
                    return jsxRuntime.jsx(jsxRuntime.Fragment, {
                        children: error
                    });
                }
            }
            if (props.message != null) {
                return jsxRuntime.jsx(jsxRuntime.Fragment, {
                    children: props.message
                });
            }
        }, [
            fieldState.error,
            getError,
            hideError,
            props.message
        ]);
        const handleChange = react.useCallback((event)=>{
            field.onChange(event);
            onChange?.(event);
        }, [
            field,
            onChange
        ]);
        const handleBlur = react.useCallback((event)=>{
            field.onBlur();
            props.onBlur?.(event);
        }, [
            field,
            props
        ]);
        return jsxRuntime.jsx(PasswordInput.PasswordInput, {
            ...props,
            ...field,
            disabled: disabled,
            error: fieldState.invalid,
            labelSuffix: getLabelSuffix?.(props.required),
            message: message,
            onBlur: handleBlur,
            onChange: handleChange,
            value: field.value ?? ''
        });
    };
    FormPasswordInput.displayName = 'Form.PasswordInput';
    return FormPasswordInput;
}

exports.createFormPasswordInput = createFormPasswordInput;
//# sourceMappingURL=Form.PasswordInput.js.map
